<template>
  <div>
    <!-- begin::Sticky Toolbar -->
    <ul class="sticky-toolbar nav flex-column pl-2 pr-2 pt-3 pb-3 mt-4">
      <li v-b-tooltip.hover.left="'微信客服'" class="nav-item mb-2">
        <a
          href="https://work.weixin.qq.com/kfid/kfccef5eea261c9f491"
          target="_blank"
          class="btn btn-sm btn-icon btn-bg-light btn-text-primary btn-hover-primary"
        >
          <i class="fab la-weixin"></i>
        </a>
      </li>
      <li v-b-tooltip.hover.left="'用户文档'" class="nav-item">
        <a
          href="/help"
          class="btn btn-sm btn-icon btn-bg-light btn-text-warning btn-hover-warning"
          target="_blank"
        >
          <i class="flaticon2-telegram-logo"></i>
        </a>
      </li>
    </ul>
    <!-- end::Sticky Toolbar -->
  </div>
</template>

<script>
export default {
  name: "KTStickyToolbar",
};
</script>
